import { Injectable } from "@angular/core";
import { IRelationshipInfo } from "../interface/relationshipInfo";
@Injectable()
export class Globals {
  public relatedAssetInfo: IRelationshipInfo[] = [];
  public IsAssetViewerClosed: any;
  public IsGridViewClosed: any;
  public IsMntViewClosed: any;
  public featureTableObj: any = null;
  public selectedTask: any;
  public showTaskWindow = false;
  public userSelectedActivity: any;
  public taskGeometry: any;
  public latitude: any;
  public longitude: any;
  public complaintID: any;
  public assetID: any;
  public activeAsset: any;  // 10/12/26 set a couple times but never referenced. proper way to manage this value is to call eeService.setActiveAsset which then emits the update
  public content: any;
  public hideSetting: any;
  public hideAdmin: any;
  public settingStyle: any;
  public adminstyle: any;
  public closeCrowdSource: any;
  public userRoles: any;
  public regions: any; //7/28/20 jcc to pass all regions for selected asset into task in order to correctly generate workers list
  public regionOverlaps: any; //12/26/25 jcc all overlapping regions of active region, for workers list not associated to selected asset
  public visibleLayerIds: any;
  public toleranceDistance = 15; // in meters added for JIRA ID:-35
  // Added by Madhuri Gupta for JIRA ID:-26 on 08/03/2021
  public assetCardDisplayMaxCol = 5;
  public taskCardDisplayMax = 5;
  // added by sowjanya JIRA ID-53 15-10-2021
  public gpstracklogData = {};
}

